import { MakeCall } from './createMakeCall';

export default (makeCall: MakeCall) => (data: {
  city: string;
  countryCode: string;
  description: string;
  name: string;
}) =>
  makeCall('POST', `/api/v2/poi`, {
    data,
  });
